import React from 'react';
import { connect, useSelector } from 'react-redux';
import UpdateViewOperatingHoursContent from '../components/pages/waiting-area/update-view-operating-hours/content';

const WaitingAreaOperatingHoursPage = (props) => {
  const waitingAreaOperatingHoursForm = useSelector((state) => state.waitingAreaReducer.waitingAreaOperatingHoursForm);
  const showUpdateWaitingAreaOperatingHoursModal = useSelector(
    (state) => state.modalReducer.showUpdateWaitingAreaOperatingHoursModal
  );
  const showViewWaitingAreaOperatingHoursModal = useSelector(
    (state) => state.modalReducer.showViewWaitingAreaOperatingHoursModal
  );
  const timezones = useSelector((state) => state.usersReducer.timezones);

  return (
    <div>
      <UpdateViewOperatingHoursContent
        timezones={timezones}
        waitingAreaOperatingHoursForm={waitingAreaOperatingHoursForm}
        waitingArea={props.waitingArea}
        showViewWaitingAreaOperatingHoursModal={showViewWaitingAreaOperatingHoursModal}
        showUpdateWaitingAreaOperatingHoursModal={showUpdateWaitingAreaOperatingHoursModal}
        updateOrView={props.updateOrView}
      />
    </div>
  );
};
export default WaitingAreaOperatingHoursPage;
